import { ReactElement } from "react";
import { Button, Flex } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";

type EntitiesCardActionsProps = {
  shouldShowSaveViewButton: boolean;
  shouldShowClearFilters: boolean;
  isBillingSaveUserGridViewFlagEnabled: boolean;
  saveViewLoading: boolean;
  handleSavedViewClicked: () => void;
  handleClearFiltersClicked: () => void;
};

export const EntitiesCardActions = ({
  shouldShowSaveViewButton,
  shouldShowClearFilters,
  isBillingSaveUserGridViewFlagEnabled,
  saveViewLoading,
  handleSavedViewClicked,
  handleClearFiltersClicked,
}: EntitiesCardActionsProps): ReactElement => {
  return (
    <Flex gap={SPACING.SMALL}>
      {shouldShowSaveViewButton && isBillingSaveUserGridViewFlagEnabled && (
        <Button
          variant="neutral"
          onClick={handleSavedViewClicked}
          icon="table-layout"
          iconPosition="left"
          disabled={saveViewLoading}
        >
          Save view
        </Button>
      )}
      {shouldShowClearFilters && isBillingSaveUserGridViewFlagEnabled && (
        <Button
          variant="neutral"
          onClick={handleClearFiltersClicked}
          icon="times"
          iconPosition="left"
        >
          Clear filters
        </Button>
      )}
    </Flex>
  );
};
